module.exports = __webpack_public_path__ + "static/scale-model-of-fremont-california-892d622794f76c74d4964ddeff25649f.png";